import React from "react";
import { SaveButton, DeleteButton, EditButton, ShowButton, Datagrid, TextField } from "react-admin";
import ExpandGrid from "./ExpandGrid";
import { generateField } from "../factory";
import  MoveButton  from "./MoveButton";
import { useMediaQuery } from '@mui/material';
import { TableCell } from "@mui/material";

import { css } from '@emotion/react';

const datagridStyles = {
  total: css({ fontWeight: 'bold' }),
  actions: css({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
  }),
};


class DefaultGrid extends React.Component {

  render() {
    const { 
      isXSmall, 
      classes, 
      filterValues, 
      resourcesFields, 
      resourcePermistions, 
      locale,
      optimized,
      fullWidth,
      ...props 
    } = this.props;
    const role = localStorage.getItem('role');

      // Read move settings from resourcePermistions
      let moveEnabled = false;
      let moveKey = "position"; // Default move key
   
    
    if (resourcePermistions) {
  

  
      if (resourcePermistions && resourcePermistions.init_values) {
        try {
          const extraConfig = JSON.parse(resourcePermistions.init_values);
          if (extraConfig.moveEnabled) {
            moveEnabled = extraConfig.moveEnabled;
          }
          if (extraConfig.moveKey) {
            moveKey = extraConfig.moveKey;
          }
        } catch (error) {
          console.error("Error parsing move settings:", error);
        }
      }
    }

    return (
      <Datagrid {...props}
        expand={resourcePermistions && resourcePermistions.is_expand ? <ExpandGrid linkedResourcePermistions={resourcePermistions} /> : null}
      >

        {resourcesFields.map((f, index) => {
          // Create unique key using source_name + index
          const uniqueKey = `field-${index}-${f.source_name || index}`;
          const fieldComponent = generateField(f, uniqueKey, props.record, 'list-view', props.id, locale);

          if (!fieldComponent) return null; // Skip null components

          return fieldComponent;
        })}

          {resourcePermistions && resourcePermistions[`${role}_edit`] === true && <EditButton />}
          {resourcePermistions && resourcePermistions[`${role}_delete`] === true && <DeleteButton />}
          {resourcePermistions && resourcePermistions[`${role}_show`] === true && <ShowButton />}

          {moveEnabled && (
          <>
            <MoveButton direction="up"  />
            <MoveButton direction="down"  />
          </>
        )}

      </Datagrid>
    );
  }
}

const DefaultListGrid = props => {
  const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return <DefaultGrid {...props} classes={datagridStyles} />;
};

export default DefaultListGrid;
